import Layout from 'components/Layout';
import { Button } from 'components/ui/button';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'store';

const SomethingWentWrong = () => {
  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode);
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="flex items-center justify-center lg:rounded-lg bg-background p-4 lg:p-10 min-h-[calc(100vh-100px)] feature-gradient-bg">
        <div className="flex flex-col-reverse lg:flex-row gap-10 lg:gap-20 items-center py-8 lg:py-0">
          <img
            src={isDarkMode ? '/404-dark.png' : '/404-light.png'}
            alt="Error"
            className="h-[300px] w-[300px] lg:h-[445px] lg:w-[445px]"
          />
          <div className="flex flex-col gap-6 lg:gap-9 text-center lg:text-left w-full lg:w-[457px] text-text-primary">
            <h1 className="text-[40px] lg:text-[80px] leading-none font-bold">Oops!</h1>
            <p className="text-[20px] lg:text-[28px]">
              Something went wrong. Please try again later.
            </p>
            <Button
              variant={'customPrimary'}
              className="w-48 rounded-lg mx-auto lg:mx-0"
              onClick={() => {
                navigate('/');
                window.location.reload();
              }}
            >
              Go back to home
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SomethingWentWrong;
